import { OffersDeliveryComponent } from './offers-delivery.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersDelivery: OffersDeliveryComponent });
